import { type Common } from '../common.js';
import { type AssistantToolType } from '../models/assistant/assistantToolType/index.js';

export class API {
  common: Common;
  baseEndpoint: string;

  constructor(common: Common) {
    this.common = common;
    this.baseEndpoint = '/assistant/tool-types';
  }

  /**
   * Fetches all voice call tool configurations from primary (source of truth).
   * Returns the list of tools defined on primary; use to drive UI and confirm all tools are defined.
   */
  async findAll(): Promise<AssistantToolType[]> {
    const url = this.common.constructPath(this.baseEndpoint);
    const result = await this.common.getJSON(url);
    return result.tools;
  }
}
